//Componentes generales
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Routes_gral from '../../utils/Routes_gral';

//Estilos
import './UserInfo.css';

//Contexto para cerrar la sesion
import authContext from '../../context/authentication/authContex';

// API
import { authUser, updateUser } from '../../api/user';
import Swal from 'sweetalert2';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faAddressCard,
    faLock,
    faEye,
    faEyeSlash
} from "@fortawesome/free-solid-svg-icons";

/*
    Componente encargaado de mostrar el dialog con el detalle de un usuario.
        Donde user es el usuario seleccionado.
        VerCerrarSesion es un booleano que condiciona la visualización de un boton (reutilización de componente).
        mode es el encargado de cerrar el dialog.
*/
function UserInfo({ user = undefined, verCerrarSesion, mode }) {
    //Context de Autenticacion
    const aContext = useContext(authContext);
    const { cerrarSesion } = aContext;

    //Inicializo navegacion
    const navigate = useNavigate();

    // Estado para cambio de contraseña
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [showCurrentPwd, setShowCurrentPwd] = useState(false);
    const [showNewPwd, setShowNewPwd] = useState(false);
    const [showRepeatPwd, setShowRepeatPwd] = useState(false);
    const [saving, setSaving] = useState(false);

    /*
        Función encargada de cerrar la sesión del usuario y redirigirlo al login.
    */
    const cerrarSesionUsuario = () => {
        cerrarSesion();
        navigate(Routes_gral.login);
    }

    /*
        Limpia todos los campos del formulario de cambio de contraseña.
    */
    const limpiarCampos = () => {
        setCurrentPassword('');
        setNewPassword('');
        setRepeatPassword('');
        setShowCurrentPwd(false);
        setShowNewPwd(false);
        setShowRepeatPwd(false);
    }

    /*
        Maneja el flujo completo de cambio de contraseña:
        valida campos, verifica la contraseña actual y actualiza la nueva.
    */
    const handleChangePassword = async () => {
        if (!currentPassword || !newPassword || !repeatPassword) {
            Swal.fire({ icon: 'warning', title: 'Campos incompletos', text: 'Completar todos los campos', customClass: { container: 'swal-high-z' } });
            return;
        }
        if (newPassword !== repeatPassword) {
            Swal.fire({ icon: 'warning', title: 'Error', text: 'Las contraseñas nuevas no coinciden', customClass: { container: 'swal-high-z' } });
            return;
        }
        if (newPassword.length < 8 || !/[a-z]/.test(newPassword) || !/[A-Z]/.test(newPassword) || !/[0-9]/.test(newPassword)) {
            Swal.fire({ icon: 'warning', title: 'Contraseña débil', text: 'La contraseña debe tener al menos 8 caracteres, una minúscula, una mayúscula y un número', customClass: { container: 'swal-high-z' } });
            return;
        }

        setSaving(true);
        try {
            // Verificar contraseña actual
            await authUser({ userName: user.userName, password: currentPassword, tenantId: user.tenantId });
        } catch (error) {
            setSaving(false);
            Swal.fire({ icon: 'error', title: 'Error', text: 'La contraseña actual es incorrecta', customClass: { container: 'swal-high-z' } });
            return;
        }

        try {
            // Actualizar contraseña
            const resp = await updateUser({ _id: user._id, password: newPassword });
            if (resp.data.newToken) {
                localStorage.setItem('token', resp.data.newToken);
            }
            Swal.fire({ icon: 'success', title: 'Contraseña actualizada', text: 'La contraseña fue cambiada correctamente', customClass: { container: 'swal-high-z' } });
            limpiarCampos();
            setShowChangePassword(false);
        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || 'Error al actualizar la contraseña', customClass: { container: 'swal-high-z' } });
        } finally {
            setSaving(false);
        }
    }

    return (
        <div className='container-gr-profile'>
            <div className='label-profile-icon'><FontAwesomeIcon icon={faAddressCard} /></div>
            <div className='container-profile'>
                <div className='label-profile'>Usuario: <div className='label-profile-data'>{user.userName}</div></div>
                <div className='label-profile'>Email:  <div className='label-profile-data'>{user.email}</div></div>
                <div className='label-profile'>Nombre Completo:  <div className='label-profile-data'>{user.fullName}</div></div>
                <div className='label-profile'>Rol:
                {user.userType.map(function (itemType, index) {
                            return (
                                <div key={itemType._id} className='label-profile-data'>{itemType.descr}</div>
                            );
                        })}
                </div>
                <div className='label-profile'>Id:  <div className='label-profile-data'>{user._id}</div></div>
            </div>

            {!verCerrarSesion &&
                <div className='btn-profile-container'><button className='btn-profile' onClick={mode}>Aceptar</button></div>
            }

            {verCerrarSesion &&
                <div className='btn-profile-container'>
                    <button
                        className='btn-profile-change-pwd'
                        onClick={() => { setShowChangePassword(!showChangePassword); if (showChangePassword) limpiarCampos(); }}
                    >
                        <FontAwesomeIcon icon={faLock} style={{ marginRight: 8 }} />
                        Cambiar Contraseña
                    </button>
                </div>
            }

            {showChangePassword && (
                <div className='change-pwd-section'>
                    <div className='change-pwd-input-group'>
                        <label>Contraseña actual</label>
                        <div className='change-pwd-input-wrapper'>
                            <input
                                type={showCurrentPwd ? 'text' : 'password'}
                                value={currentPassword}
                                onChange={e => setCurrentPassword(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={showCurrentPwd ? faEyeSlash : faEye}
                                className='change-pwd-eye'
                                onClick={() => setShowCurrentPwd(!showCurrentPwd)}
                            />
                        </div>
                    </div>
                    <div className='change-pwd-input-group'>
                        <label>Nueva contraseña</label>
                        <div className='change-pwd-input-wrapper'>
                            <input
                                type={showNewPwd ? 'text' : 'password'}
                                value={newPassword}
                                onChange={e => setNewPassword(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={showNewPwd ? faEyeSlash : faEye}
                                className='change-pwd-eye'
                                onClick={() => setShowNewPwd(!showNewPwd)}
                            />
                        </div>
                    </div>
                    <div className='change-pwd-input-group'>
                        <label>Repetir contraseña</label>
                        <div className='change-pwd-input-wrapper'>
                            <input
                                type={showRepeatPwd ? 'text' : 'password'}
                                value={repeatPassword}
                                onChange={e => setRepeatPassword(e.target.value)}
                            />
                            <FontAwesomeIcon
                                icon={showRepeatPwd ? faEyeSlash : faEye}
                                className='change-pwd-eye'
                                onClick={() => setShowRepeatPwd(!showRepeatPwd)}
                            />
                        </div>
                    </div>
                    <div className='btn-profile-container'>
                        <button
                            className='btn-profile'
                            onClick={handleChangePassword}
                            disabled={saving}
                        >
                            {saving ? 'Guardando...' : 'Guardar'}
                        </button>
                    </div>
                </div>
            )}

            {verCerrarSesion &&
                <div className='btn-profile-container'><button className='btn-profile-cs' onClick={cerrarSesionUsuario}>Cerrar Sesión</button></div>
            }
        </div>
    );
}

export default UserInfo
